
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'
import {required} from 'vuelidate/lib/validators'
import MailBlocTextModel from '@/models/MailBlocTextModel'

@Component({
  components: {
    BaseFormContainer,
    CheckboxYesNo
  },
  validations: {
    form: {
      LIBELLE: {
        required
      },
      TEXTE: {
        required
      }
    }
  }
})
export default class MailBlocTextForm extends BaseForm {
  model = MailBlocTextModel
}
